// extracted by mini-css-extract-plugin
export default {"wrap":"ShiftFilter_wrap__EdkZJ","label":"ShiftFilter_label__z1D0L","dropdown":"ShiftFilter_dropdown__NIClv"};